import { render } from "./SourceManagement.vue?vue&type=template&id=38ec5b3f&scoped=true"
import script from "./SourceManagement.vue?vue&type=script&lang=js"
export * from "./SourceManagement.vue?vue&type=script&lang=js"

import "./SourceManagement.vue?vue&type=style&index=0&id=38ec5b3f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38ec5b3f"]])

export default __exports__